import React from "react";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFeatures } from "flagged";

import MasterLayout from "@layouts/MasterLayout.react";
import { Div, Image, Button } from "@components/Generics.react";
import { settings } from "@config/settings/app.settings";
import RecommendedArticles from "@components/RecommendedArticles.react";
import TermsPage from "./panels/TermsPage.react";
import ReactPlayer from "react-player/lazy";
import { Divider } from "semantic-ui-react";

export default function DesktopHome(props) {
    const user = useSelector((state) => state.auth.user);
    const { t } = useTranslation("common");
    const features = useFeatures();

    const stages = settings.gamification.stages;
    const userStage = settings.home[user.stage || stages.length];

    const pageContent =
        user.license.termsAccepted || !features.general.acceptTerms ? (
            <Div fullht fluid flex top-aligned>
                <Div wd="calc(100% - 360px)" padSides>
                    <Div fluid flex top-aligned>
                        <Div wd="40%" altText huge uppercase>
                            <Div wd="40%" altText huge uppercase txtCharcoal>
                                Welcome{" "}
                            </Div>
                            {user.branding?.name
                                ? "to " + user.branding?.name
                                : ""}
                        </Div>
                        <Div wd="60%">
                            <Div
                                rounded
                                noOverflow
                                gutter
                                className="video-responsive"
                            >
                                <ReactPlayer
                                    className="react-player"
                                    url={user.branding?.homeVideo}
                                    width="100%"
                                    height="100%"
                                />
                            </Div>
                        </Div>
                    </Div>
                    <Divider />
                    <br />
                    <Div ash basepad>
                        <Div altText large uppercase gutter>
                            How it works:
                        </Div>
                        <ul>
                            <li>
                                See the video to understand the simulation
                                premise and flow
                            </li>
                            <li>
                                You will be taking decisions in the Decision Hub
                            </li>
                            <li>
                                All information you need to take these decisions
                                are in the Infobase
                            </li>
                            <li>
                                You can track your progress and performance in
                                the Reports section
                            </li>
                            <li>
                                And we are always there to help. Just ping us on
                                the HelpDesk.
                            </li>
                        </ul>
                        <Button
                            primary
                            href="/library"
                            content="Start Simulation"
                        />
                    </Div>
                </Div>
                <Div wd="360px" fullht basepad peat rounded>
                    <Div gutter big uppercase altText>
                        Quick Links:
                    </Div>
                    <Div
                        relative
                        fluid
                        style={{ height: "0", paddingBottom: "133%" }}
                    >
                        {userStage &&
                            _.map(userStage.images, ({ src, coords }, idx) => {
                                return (
                                    <NavLink
                                        to={t(`home.links.${src}`)}
                                        key={`homeelm-${idx}`}
                                    >
                                        <Image
                                            src={t(`home.images.${src}`)}
                                            style={{
                                                position: "absolute",
                                                left: `${coords[0]}%`,
                                                top: `${coords[1]}%`,
                                                width: `${coords[2]}%`,
                                            }}
                                        />
                                    </NavLink>
                                );
                            })}
                    </Div>
                </Div>
            </Div>
        ) : (
            <TermsPage />
        );
    // ========================= Render Function =================================
    return (
        <MasterLayout
            title={"Welcome"}
            mainPanel={pageContent}
            rightPanelName={t(`components.recommended`)}
            rightPanel={<RecommendedArticles />}
            rootPage={true}
            hidePanelToggle
            startFullScreen={true}
        />
    );
}
